import { useState } from 'react';

import { toast } from '@anyx/shared-ui';

import { exportCsv } from '../api';

export const useExportBroadcastOfferCsv = ({
  platform = 'line',
}: {
  platform: 'line' | 'messenger' | 'whatsapp';
}) => {
  const [loading, setLoading] = useState(false);

  const exportBroadcastOfferCsv = async (broadcastId: string) => {
    setLoading(true);
    const success = await exportCsv({
      uri: `broadcasts/${platform}/csv/${broadcastId}/offer`,
    });
    setLoading(false);

    if (!success) toast.error();
  };

  return {
    loading,
    exportBroadcastOfferCsv,
  };
};
